import styled from "styled-components";
import { colors } from "../../../theme/color";
import fipayFonts from "../../../theme/index";

interface THProps {
  cellWidth: string;
}
interface TBodyTRProps {
  even: boolean;
}

export const TableWrapperDesktop = styled.table`
  width: 100%;
  /* height: 332px; */
  /* border: 2px solid black; */
  border-collapse: collapse;
  text-align: center;
  overflow: hidden;

  @media screen and (max-width: 2560px) {
    display: block;
  }
  @media screen and (max-width: 1440px) {
    display: block;
  }

  @media screen and (max-width: 430px) {
    display: none;
  }
  @media screen and (max-width: 375px) {
    display: none;
  }
`;
export const TableWrapperMobile = styled.table`
  width: 90%;
  border-collapse: collapse;
  text-align: center;
  overflow: hidden;

  @media screen and (max-width: 2560px) {
    display: none;
  }
  @media screen and (max-width: 1440px) {
    display: none;
  }

  @media screen and (max-width: 430px) {
    display: block;
  }
  @media screen and (max-width: 375px) {
    display: block;
  }
`;

// Table head
export const THead = styled.thead`
  position: sticky;
  width: 100%;
  z-index: 100;
  /* height: 44px; */
  background-color: #f7f7f7;
  /* background-color: red; */
`;

export const THeadTR = styled.tr`
  height: 44px;
  /* border: 2px solid green; */
`;

export const TH = styled.th<THProps>`
  /* border: 2px solid white; */
  width: ${(props) => props.cellWidth};
  /* padding-left: 24px; */
  padding: 12px 20px;
  text-align: left;
`;

export const TableHeadText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.DARK_GRAY};
`;

// table Body
// export const TBodyContainer = styled.div`
//   width: 100%;
//   height: 100%;
//   flex-shrink: 0;
//   border-radius: 10px;
//   box-sizing: border-box;
//   border: 1px solid var(--General-Stroke, #e8eaed);
//   background: var(--General-White, #fff);
//   box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
//   padding: 20px 50px 20px 20px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

export const BodyWrapper = styled.div`
  width: 100%;
  /* height: 160px; */
`;

export const TBody = styled.tbody`
  width: 100%;
  /* height: 288px; */
  border-collapse: collapse;
  text-align: center;
  overflow: hidden;
  flex-shrink: 0;
  // border: 2px solid orange;
  /* display: flex;
  flex-direction: column;
  align-items: center; */
`;

export const BodyRowWrapper = styled.div`
  /* height: 55px; */
  /* border: 2px solid blue; */
`;

export const TBodyTR = styled.tr<TBodyTRProps>`
  /* width: 100%; */
  background-color: ${(props) => (props.even ? `${colors.White}` : "#f7f7f7")};

  /* border: 2px solid blue; */
`;

interface TDProps {
  cellWidth: string;
}
export const TD = styled.td<TDProps>`
  width: ${(props) => props.cellWidth};

  /* padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 16px; */
  /* padding: 5px 15px 5px 15px ; */
  padding: 12px 20px;
  text-align: left;
  box-sizing: border-box;
`;

export const StatusTD = styled(TD)`
  /* width: 100%; */
  text-align: left;
  box-sizing: border-box;
`;

export const IconTD = styled(TD)`
  cursor: pointer;
  box-sizing: border-box;
`;

export const QRCodeTD = styled(TD)`
  /* width: 30%; */
  /* text-align: left; */
  /* font-family: "Open Sans", sans-serif; */
  font-family: "GT Walsheim Pro";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0rem;
  /* text-align: left; */
  box-sizing: border-box;
  /* border: 2px solid red; */
`;

export const TDFirst = styled.td<TDProps>`
  /* width: ${(props) => props.cellWidth}; */

  padding: 16px 20px 16px 20px;
  /* border: 2px solid blue; */
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  /* align-items: center; */
  gap: 5px;
`;

export const TableBodyText = styled.div`
  text-align: left;
  margin-left: 8px;
  width: 100%;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  /* font-weight: ${fipayFonts.fipayFonts.fontWeight.regular}; */
  /* letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body}; */
  /* line-height: ${fipayFonts.fipayFonts.lineHeight.footer1}; */
  line-height: 20px;
  color: ${colors.BLACK};
`;

export const TableBodyTextII = styled.div`
  text-align: left;
  width: 100%;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  /* font-weight: ${fipayFonts.fipayFonts.fontWeight.regular}; */
  /* letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body}; */
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.BLACK};
  margin-left: 1.5rem;
`;
export const DeleteBox = styled.div`
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 70%;
  left: 90%;
  transform: translate(-50%, -50%);
  z-index: 999999;
`;

export const DeleteText = styled.p`
  margin-bottom: 10px;
`;

export const DeleteButton = styled.button`
  background-color: #ff4d4f;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #ff7875;
  }
`;
